import { __, compose, concat, replace, toLower } from 'ramda';

export const setElementClass = (elementName, classAction) => compose(
  concat(__, `-${classAction}`),
  toLower,
  replace(/[()]/g, '_'),
  replace(/[ .]/, '-')
)(elementName);
